<template>
  <div class="app-locales">
    <Dropdown
      :options="localeOptions"
      v-model="$i18n.locale"
      @input="onLocaleChange"
      :itemFormat="key => key"
      class="as-link"
    >
      <template v-slot:renderValue="{opt, title}">
        <span v-if="title" class="app-locales__title">{{ opt.key }}</span>
        <span
          v-else
          class="app-locales__value"
        >{{ opt.key }}</span>
      </template>
    </Dropdown>
  </div>
</template>

<script>
  import { Dropdown } from "../elements";
  import ajax         from "../ajax";

  export default {
    name: 'Locales',
    components: {
      Dropdown
    },
    data() {
      return {
        localeOptions: window.envs.availableLocales
      };
    },
    methods: {
      onLocaleChange
    },
  }

  function onLocaleChange(locale) {
    if (locale == this.$route.params.locale) {
      return;
    }
    if (!this.$i18n.messages[locale]) {
      [
        `${location.origin}/locale/${locale}`,
        //`${window.envs.authTarget}/locale/${locale}`,
      ].unique().forEach(url => {
        ajax.get(url).then(response => {
          this.$i18n.mergeLocaleMessage(locale, response.data.content[locale]);
          this.$i18n.locale = locale;
        });
      });
    }
    let route = this.$route;
    this.$router.push({
      ...route,
      params: {
        ...route.params,
        locale
      }
    });
  }
</script>
